import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import logo from '../assets/logo.svg'; // with import
import { ToastContainer } from 'react-toastify';
import qs from "qs";
import ApiCall from '../utils/ApiCall';

export const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const history = useHistory();



    // useEffect(() => {
    //     async function calistir() {
    //         ApiCall('KKKaptan/agency/GetUsersStation', 'GET', null, true).then(answer => answer && localStorage.setItem('durak', answer.data));
    //     }
    //     calistir();
    // }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // const params = { grant_type: "password", username: username, password: password };

        // fetch('https://api.kamilkoc.com.tr/KKKaptan/token', {
        //     method: 'POST',
        //     headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        //     body: qs.stringify(params)
        // }).then((res) => {
        //     if (!res.ok) {
        //         showErrorToast(res.message);
        //         throw Error('could not fetch the data for that resource');
        //     }
        //     return res.json();
        // }).then(data => {
        //     if (data.Durum === 200)
        //         showSuccessToast("Giriş yapıldı");
        //     else
        //         showErrorToast(data.Mesaj);

        //     localStorage.setItem('username', username);
        //     localStorage.setItem('token', data.access_token);
        //     localStorage.setItem('data', JSON.stringify(data));

        //     var dt = new Date();
        //     dt.setSeconds(dt.getSeconds() + data.expires_in);
        //     localStorage.setItem('token_time', dt);

        //     history.push('/voucher');
        // }).catch(err => {
        //     showErrorToast(err.message);
        // });


        // let answer = await ApiCall('KKKaptan/token', 'POST', qs.stringify(params), false);
        // if (answer) {

        //     localStorage.setItem('username', username);
        //     localStorage.setItem('token', answer.access_token);
        //     localStorage.setItem('data', JSON.stringify(answer));

        //     var dt = new Date();
        //     dt.setSeconds(dt.getSeconds() + answer.expires_in);
        //     localStorage.setItem('token_time', dt);

        //     setToken(answer);

        //     let info = await ApiCall('KKKaptan/agency/GetUsersStation', 'GET', null, true);
        //     if (info && info.success) {
        //         localStorage.setItem('durak', info.data);
        //     }

        //     history.push('/voucher');


        // }

        // ApiCall('token', 'POST', qs.stringify(params), false)
        //     .then(res => {
        //         console.log(res);
        //         if (res.access_token) {
        //             localStorage.setItem('username', username);
        //             localStorage.setItem('token', res.access_token);
        //             localStorage.setItem('data', JSON.stringify(res));

        //             var dt = new Date();
        //             dt.setSeconds(dt.getSeconds() + res.expires_in);
        //             localStorage.setItem('token_time', dt);
        //             return true;
        //         }
        //         else
        //             return false;
        //     }
        //     ).then(res => {
        //         if (res) {
        //             ApiCall('agency/GetUsersStation', 'GET', null, true)
        //                 .then(res => {
        //                     console.log(res);
        //                     if (res.success) {
        //                         localStorage.setItem('durak', res.data);
        //                         history.push('/voucher');
        //                     }
        //                 })
        //         }
        //     });


        const params = { username: username, password: password };

        const res = await ApiCall('token', 'POST', params, false);
        if (res.data.access_token) {
            localStorage.setItem('username', username);
            localStorage.setItem('token', res.data.access_token);
            localStorage.setItem('data', JSON.stringify(res.data));

            var dt = new Date();
            dt.setSeconds(dt.getSeconds() + res.data.expires_in);
            localStorage.setItem('token_time', dt);

            const response = await ApiCall('agency/GetUsersStation', 'GET', null, true);
            console.log(response);
            if (response.data.success) {
                localStorage.setItem('durak', response.data.data);
                history.push('/voucher');
            }
        }






    }

    return (
        <div className="row" style={{ 'height': '100%' }}>
            <ToastContainer />
            <form className="loginForm" onSubmit={handleSubmit}>
                <div>
                    <img src={logo} style={{ 'marginBottom': '30px' }} alt="deneme" />
                </div>
                {/* <div style={{ 'textAlign': 'center' }}>
                    <h3>Kullanıcı Girişi</h3>
                </div> */}
                <div className="form-group">
                    <input type="text" className="form-control" placeholder="Kullanıcı Adı" name="username" value={username} onChange={(e) => setUsername(e.target.value)} />
                </div>
                <div className="form-group">
                    <input type="password" className="form-control" placeholder="Şifre" name="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <input type="submit" className="btn btn-lg btn-block button" value="Giriş" />
            </form>
        </div>
    );
}

export default Login;